const MAGIC = new TextEncoder().encode("OCINF001");
const FIXED_HEADER_BYTES = MAGIC.byteLength + 4;
const MAX_METADATA_BYTES = 1024 * 1024;
const MAX_PAYLOADS = 16;
export const INFERENCE_ENVELOPE_CONTENT_TYPE = "application/vnd.opencloud.inference-envelope";
export function encodeInferenceEnvelope(metadata, payloads) {
    if (payloads.length > MAX_PAYLOADS) {
        throw new Error("Inference envelope has too many payloads");
    }
    const metadataBytes = new TextEncoder().encode(JSON.stringify({ metadata, payloadLengths: payloads.map((item) => item.byteLength) }));
    if (metadataBytes.byteLength > MAX_METADATA_BYTES) {
        throw new Error("Inference envelope metadata is too large");
    }
    const payloadBytes = payloads.reduce((total, item) => total + item.byteLength, 0);
    const encoded = new Uint8Array(FIXED_HEADER_BYTES + metadataBytes.byteLength + payloadBytes);
    encoded.set(MAGIC, 0);
    new DataView(encoded.buffer).setUint32(MAGIC.byteLength, metadataBytes.byteLength);
    encoded.set(metadataBytes, FIXED_HEADER_BYTES);
    let offset = FIXED_HEADER_BYTES + metadataBytes.byteLength;
    for (const payload of payloads) {
        encoded.set(payload, offset);
        offset += payload.byteLength;
    }
    return encoded;
}
export function decodeInferenceEnvelope(value) {
    if (value.byteLength < FIXED_HEADER_BYTES) {
        throw new Error("Inference envelope is truncated");
    }
    for (let index = 0; index < MAGIC.byteLength; index += 1) {
        if (value[index] !== MAGIC[index]) {
            throw new Error("Inference envelope magic is invalid");
        }
    }
    const metadataLength = new DataView(value.buffer, value.byteOffset, value.byteLength).getUint32(MAGIC.byteLength);
    if (metadataLength < 2 ||
        metadataLength > MAX_METADATA_BYTES ||
        FIXED_HEADER_BYTES + metadataLength > value.byteLength) {
        throw new Error("Inference envelope metadata length is invalid");
    }
    let decoded;
    try {
        decoded = JSON.parse(new TextDecoder().decode(value.subarray(FIXED_HEADER_BYTES, FIXED_HEADER_BYTES + metadataLength)));
    }
    catch {
        throw new Error("Inference envelope metadata is invalid");
    }
    if (!decoded || typeof decoded !== "object" || Array.isArray(decoded)) {
        throw new Error("Inference envelope metadata is invalid");
    }
    const record = decoded;
    if (!Array.isArray(record.payloadLengths) ||
        record.payloadLengths.length > MAX_PAYLOADS ||
        record.payloadLengths.some((length) => typeof length !== "number" ||
            !Number.isSafeInteger(length) ||
            length < 0)) {
        throw new Error("Inference envelope payload lengths are invalid");
    }
    const payloads = [];
    let offset = FIXED_HEADER_BYTES + metadataLength;
    for (const length of record.payloadLengths) {
        const end = offset + length;
        if (end > value.byteLength) {
            throw new Error("Inference envelope payload is truncated");
        }
        payloads.push(value.slice(offset, end));
        offset = end;
    }
    if (offset !== value.byteLength) {
        throw new Error("Inference envelope has trailing bytes");
    }
    return { metadata: record.metadata, payloads };
}
//# sourceMappingURL=inference-envelope.js.map